<div class="pill-list" [class.wrap]="wrap">
  @for (item of visibleItems; track item.id) {
    <motn-pill
      [color]="color"
      [fill]="fill"
      [value]="item.value"
      [removable]="removable"
      (remove)="remove.emit(item)"
    >{{ item.label }}</motn-pill>
  }

  @if (hiddenCount > 0) {
    <span
      class="pill-list-trigger"
      cdkOverlayOrigin
      #triggerOrigin="cdkOverlayOrigin"
      (click)="toggle($event)"
    >+{{ hiddenCount }}</span>

    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="triggerOrigin"
      [cdkConnectedOverlayOpen]="overlayOpen"
      [cdkConnectedOverlayPositions]="overlayPositions"
      [cdkConnectedOverlayViewportMargin]="8"
      (overlayOutsideClick)="close()"
    >
      <div class="pill-list-panel" (motnClickOutsideService)="close()">
        @for (item of hiddenItems; track item.id) {
          <motn-pill
            [color]="color"
            [fill]="fill"
            [value]="item.value"
            [removable]="removable"
            (remove)="remove.emit(item)"
          >{{ item.label }}</motn-pill>
        }
      </div>
    </ng-template>
  }
</div>
